import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAlleenBeheer } from '../context/FeatureContext';

// Route-guard voor lespagina's zonder eigen schoolfunctie (toets maken,
// bewerken, monitor, voorbeeld, toetsstatistiek, docentkant coaching).
// Een beheerder zonder lestaak (migratie 074) komt hier niet, ook niet via
// een directe URL; hij gaat terug naar zijn eigen dashboard. Pagina's mét
// schoolfunctie (toetsen, communicatie, lesmodus, ...) regelt FeatureRoute
// al: voor hem staan die functies uit.
export default function LesRoute({ children }) {
  const alleenBeheer = useAlleenBeheer();
  if (alleenBeheer) return <Navigate to="/dashboard-new" replace />;
  return children;
}
